export { default } from './use-get-record-by-id'
